import { Link } from 'react-router-dom';
import Header from '../components/HeaderThree';
import Footer from '../components/Footer';
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import Shipping from '../components/Shipping';
import NewsletterTwo from "../components/NewsletterTwo";

const NotFoundPage = () => {
    return (
        <>
            <ColorInit color={true} />
            <Preloader />
            <ScrollToTop smooth color="var(--brand-primary)" />
            <Header />
            
            <section className="not-found-section py-60 bg-white">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 text-center">
                            <div className="not-found-content">
                                <div className="mb-40">
                                    <h1 className="display-1 fw-bold text-main-600 opacity-20 mb-n40" style={{ fontSize: '180px' }}>404</h1>
                                </div>
                                <h2 className="mb-16 fw-bold text-gray-900">Oops! Page Not Found</h2>
                                <p className="text-gray-500 mb-40 text-lg">
                                    The page you are looking for might have been removed, had its name changed, or is temporarily unavailable. 
                                    Let's get you back on track!
                                </p>
                                <div className="flex-center gap-16">
                                    <Link 
                                        to="/" 
                                        className="btn btn-main-600 px-40 py-18 rounded-pill fw-bold shadow-sm transition-2"
                                        style={{ backgroundColor: 'var(--brand-primary)', color: 'white' }}
                                    >
                                        Back to Home
                                    </Link>
                                    <Link 
                                        to="/shop" 
                                        className="btn btn-main-50 text-main-600 px-40 py-18 rounded-pill fw-bold border border-main-100 transition-2 hover-bg-main-600 hover-text-white"
                                    >
                                        Go to Shop
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <Shipping />

            {/* NewsletterTwo */}
      <NewsletterTwo />
            <Footer />
        </>
    );
};

export default NotFoundPage;